module.exports = __webpack_public_path__ + "static/email2-5f3b2030b00bfc708f1199d935cf0704.jpg";